/**
 * Editions Floating Badge - Embedded in Lab Software page
 * Three LARIS editions with badge-over-image layout
 */
import React, { useState, useRef } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { LARIS_EDITIONS } from "./EditionsData";
import "./EditionsFloatingBadge.css";

export function EditionsFloatingBadge({ editions = LARIS_EDITIONS, showImages = true }) {
  const [inView, setInView] = useState(false);
  const wasVisibleRef = useRef(false);

  const handleVisibility = (visible) => {
    if (visible && !wasVisibleRef.current) {
      setInView(true);
      wasVisibleRef.current = true;
    }
  };

  return (
    <VisibilitySensor onChange={handleVisibility} partialVisibility offset={{ bottom: 80 }}>
      <div className={`editions-section-wrap editions-modern ${inView ? "editions-in-view" : ""}`}>
        <div className={`editions-floating-grid editions-stagger ${!showImages ? "editions-no-images" : ""}`}>
          {editions.map((item, idx) => (
            <div key={item.id} className="editions-floating-card" data-edition-index={idx}>
              <div className="editions-floating-header">
                {showImages && (
                  <div className="editions-floating-img-wrap">
                    <img src={item.img} alt="" />
                    <span className="editions-floating-badge">{item.label || String(idx + 1).padStart(2, "0")}</span>
                  </div>
                )}
                {!showImages && <span className="editions-floating-badge-only">{item.label || String(idx + 1).padStart(2, "0")}</span>}
              </div>
              <div className="editions-floating-body">
                <ul className="editions-bullet-list">
                  {item.detail.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default EditionsFloatingBadge;
